import { Layers } from 'lucide-react'
import { Link, useLocation } from 'react-router'
import { AppSwitcher } from '@/components/layout/breadcrumbs/app/app-switcher'
import { PipelineSwitcher } from '@/components/layout/breadcrumbs/app/pipeline-switcher'
import {
  BreadcrumbItem,
  BreadcrumbPage,
  BreadcrumbLink,
  BreadcrumbSeparator,
} from '@/components/ui/breadcrumb'
import {
  Tooltip,
  TooltipTrigger,
  TooltipContent,
} from '@/components/ui/tooltip'
import { useCompanyPath } from '@/lib/hooks'

const AppsIconBreadcrumbItem = () => {
  const { getCompanyPath } = useCompanyPath()
  return (
    <BreadcrumbItem>
      <Link to={getCompanyPath({ pathname: '/apps' })}>
        <Tooltip delayDuration={1000}>
          <BreadcrumbPage className="cursor-pointer p-2 flex items-center rounded-md text-muted-foreground hover:bg-muted hover:text-foreground">
            <TooltipTrigger>
              <BreadcrumbLink asChild>
                <div className="cursor-pointer">
                  <Layers className="size-3.5" />
                  <span className="sr-only">Applications</span>
                </div>
              </BreadcrumbLink>
            </TooltipTrigger>
          </BreadcrumbPage>
          <TooltipContent sideOffset={8}>
            <span>Applications</span>
          </TooltipContent>
        </Tooltip>
      </Link>
    </BreadcrumbItem>
  )
}

export const AppBreadcrumbs = () => {
  const { pathname } = useLocation()

  return (
    <>
      {pathname === '/apps' || pathname === '/apps/create-pipeline' ? (
        <BreadcrumbItem>
          <BreadcrumbPage className="flex items-center gap-2 px-2">
            <Layers className="size-3.5" />
            <span className="font-medium">Applications</span>
          </BreadcrumbPage>
        </BreadcrumbItem>
      ) : null}
      {pathname === '/apps/create' ? (
        <>
          <AppsIconBreadcrumbItem />
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbPage className="px-2 font-medium">
              Create application
            </BreadcrumbPage>
          </BreadcrumbItem>
        </>
      ) : null}
      {pathname.startsWith('/app/') ? (
        <>
          <AppsIconBreadcrumbItem />
          <BreadcrumbSeparator />
          <AppSwitcher />
        </>
      ) : null}
      {pathname.startsWith('/pipeline/') ? (
        <>
          <AppsIconBreadcrumbItem />
          <BreadcrumbSeparator />
          <PipelineSwitcher />
        </>
      ) : null}
    </>
  )
}
